module.exports = __webpack_public_path__ + "static/media/YM54_7.c935cbab.jpg";